import React from 'react';
import { CircularProgress, Box } from '@mui/material';

export const TopCircularProgress = (props) => <CircularProgress sx={{ zIndex: 3 }} variant="determinate" {...props} />;

export const BottomCircularProgress = ({ value, ...props }) => (
  <CircularProgress
    sx={{ zIndex: 2, color: '#eee', position: 'absolute' }}
    variant="determinate"
    value={100}
    {...props}
  />
);

const CircularProgressWithLabel = ({ children, ...props }) => (
  <Box position="relative" display="inline-flex">
    <TopCircularProgress {...props} />
    <BottomCircularProgress {...props} />
    <Box
      sx={{
        padding: props.padding || '3px 3px 3px 3px',
        top: 0,
        left: props.left || 0,
        bottom: 0,
        right: 0,
        position: 'absolute',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        flexDirection: 'column',
        wordBreak: 'break-word',
      }}
    >
      {children}
    </Box>
  </Box>
);

export default CircularProgressWithLabel;
